// src/admin/pages/Process/components/process/ProcessFilterBar.js
import React from "react";
import Select from "react-select";

export default function ProcessFilterBar({
  startDate,
  endDate,
  onChangeStart,
  onChangeEnd,
  restaurants,
  selectedRestaurant,
  onChangeRestaurant,
  onFilter,
}) {
  const restaurantOptions = [
    { value: "all", label: "Tutti" },
    ...restaurants.map((r) => ({ value: String(r.id), label: r.name })),
  ];

  const selectedOption =
    restaurantOptions.find((opt) => opt.value === String(selectedRestaurant)) ||
    restaurantOptions[0];

  return (
    <div style={styles.filterBar}>
      <div style={styles.field}>
        <label>Dal:</label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => onChangeStart(e.target.value)}
          style={styles.input}
        />
      </div>
      <div style={styles.field}>
        <label>Al:</label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => onChangeEnd(e.target.value)}
          style={styles.input}
        />
      </div>
      <div style={styles.field}>
        <label>Ristorante:</label>
        <Select
          options={restaurantOptions}
          value={selectedOption}
          onChange={(opt) => onChangeRestaurant(opt.value)}
          isSearchable
        />
      </div>
      <button style={styles.button} onClick={onFilter}>
        Filtra
      </button>
    </div>
  );
}

const styles = {
  filterBar: {
    display: "flex",
    alignItems: "flex-end",
    gap: "1rem",
    backgroundColor: "#fff",
    padding: "1rem",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    flexWrap: "wrap",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    minWidth: "160px",
  },
  input: {
    padding: "0.4rem",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  button: {
    backgroundColor: "#FF6600",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "0.6rem 1rem",
    cursor: "pointer",
  },
};
